/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // hide all sections
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // remove free gift if under threshold
    if (cartSettings.upsell_product) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.handle === cartSettings.upsell_product && cart.total_price < cartSettings.upsell_minimum) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // check if cart bot is enabled
    if (settings.cartbot === true) {
        // create update payload
        let updatePayload = {};

        // create array of handles for cartbot_add_v2
        let cartbotAdd = [];
        settings.cartbot_add_v2.forEach((item) => {
            cartbotAdd.push(item.handle)
        })

        // remove all products from cartbot
        cart.items.forEach(item => {
            if (cartbotAdd.includes(item.handle)) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // update item count
    document.querySelector("#headerIconsCart").setAttribute("count", cart.item_count);

    // determine if shipping bar should be shown
    if (cart.total_price < cartSettings.free_shipping_minimum) {
        document.querySelector("#miniCartHeaderShipping").classList.remove("active");
    } else {
        document.querySelector("#miniCartHeaderShipping").classList.add("active");
    }

    // update free shipping bar
    const progress = cart.total_price / cartSettings.free_shipping_threshold * 100;
    document.querySelector("#miniCartHeaderShippingBarProgress").style.width = `${progress}%`;
    if (progress < 100) {
        document.querySelector("#miniCartHeaderShippingTitle").innerHTML = cartSettings.free_shipping_under.replace("|MONEY|", price(cartSettings.free_shipping_threshold - cart.total_price));
    } else {
        document.querySelector("#miniCartHeaderShippingTitle").innerHTML = cartSettings.free_shipping_unlocked;
    }

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // show cart
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // reset container
    document.querySelectorAll(".miniCartBodyItem:not(.gift)").forEach(function (element) {
        element.remove();
    });

    // append cart
    cart.items.forEach(function (item) {
        // price html
        function saleHTML() {
            // check for line item discounts
            if (item.original_line_price > item.final_line_price) {
                return price(item.original_line_price);
            }
            // check for compare at discount
            else if (handleToCompareAtPrice[item.handle] && handleToCompareAtPrice[item.handle] * item.quantity > item.final_line_price) {
                return price(handleToCompareAtPrice[item.handle] * item.quantity);
            }
            // default price
            else {
                return "";
            }
        }

        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem ${item.handle === cartSettings.upsell_product ? 'disableEdit' : ''}" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemTitle">${item.title}</div>
                    <div class="miniCartBodyItemPrice">${price(item.final_line_price)} <s>${saleHTML()}</s></div>
                    <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus">-</button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus">+</button>
                    </div>
                </div>
                <div>
                    <button class="miniCartBodyItemRemove">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <g opacity="0.6">
                            <path d="M7.19922 9.82642H24.2659M13.5992 14.8521V22.3905M17.8659 14.8521V22.3905M8.26589 9.82642L9.33255 24.9033C9.33255 25.5698 9.55731 26.2089 9.95739 26.6802C10.3575 27.1514 10.9001 27.4162 11.4659 27.4162H19.9992C20.565 27.4162 21.1076 27.1514 21.5077 26.6802C21.9078 26.2089 22.1326 25.5698 22.1326 24.9033L23.1992 9.82642M12.5326 9.82642V6.05719C12.5326 5.72397 12.6449 5.4044 12.845 5.16878C13.045 4.93315 13.3163 4.80078 13.5992 4.80078H17.8659C18.1488 4.80078 18.4201 4.93315 18.6201 5.16878C18.8202 5.4044 18.9326 5.72397 18.9326 6.05719V9.82642" stroke="#151515" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                        </svg>                    
                    </button>
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem:not(.gift)`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }
    });

    // only run if upsell is enabled
    if (cartSettings.upsell_product) {
        // check if the wagon is in the cart
        let upsellInCart = cart.items.find(item => item.handle === cartSettings.upsell_product);

        // if all upsells are hidden or the wagon is not in the cart, hide upsell section
        if (!upsellInCart && cart.total_price >= cartSettings.upsell_minimum) {
            document.querySelector("#miniCartUpsell").classList.add("active");
        }
    }

    // calculate the total original price to show the discount
    let totalOriginalPrice = 0;

    // check if cart bot is enabled AND the trigger is in the cart
    if (settings.cartbot === true && cart.items.find(item => item.handle === settings.cartbot_trigger)) {
        // add all products to the total
        settings.cartbot_add_v2.forEach((item) => {
            totalOriginalPrice += item.compare_at_price;
        });

        // show the free products
        document.querySelectorAll(".miniCartBodyItem.gift").forEach((item) => {
            item.classList.add("active");
        })
    } else {
        // hide the free products
        document.querySelectorAll(".miniCartBodyItem.gift").forEach((item) => {
            item.classList.remove("active");
        })
    }

    // calculate sum of compare at prices
    cart.items.forEach(item => {
        // if there is a compare at price, use that max of the compare at price and the original line price
        if (handleToCompareAtPrice[item.handle]) {
            totalOriginalPrice += Math.max((handleToCompareAtPrice[item.handle] * item.quantity), item.original_line_price);
        } else {
            totalOriginalPrice += item.original_line_price;
        }
    });

    // update subtotal
    if (totalOriginalPrice > cart.total_price) {
        document.querySelector("#miniCartFooter span:last-child").innerHTML = `${price(cart.total_price)} <s>${price(totalOriginalPrice)}</s>`;
    } else {
        document.querySelector("#miniCartFooter span:last-child").innerHTML = price(cart.total_price);
    }
}

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// Add upsell to cart
document.querySelector(".miniCartUpsellBodyProductBtn").addEventListener("click", async function () {
    this.classList.add("loading");

    // determine if there is a dropdown
    let variantID = parseInt(this.dataset.product);
    let dropdown = this.parentElement.querySelector(".miniCartUpsellBodyProductVariants");
    if (dropdown) {
        variantID = parseInt(dropdown.value);
    }

    await addProduct({
        id: variantID,
        quantity: 1
    });

    this.classList.remove("loading");

    await openCart();
});

// checkout
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // start loading
    this.classList.add("loading");

    // check for cartbot AND trigger is in the cart
    if (settings.cartbot === true && cart.items.find(item => item.handle === settings.cartbot_trigger)) {
        // determine trigger quantity
        let triggerQuantity = 0;
        cart.items.forEach((item) => {
            if (item.handle === settings.cartbot_trigger) {
                triggerQuantity = item.quantity;
            }
        });

        // create array of add to cart payload
        let payload = [];
        settings.cartbot_add_v2.forEach((item) => {
            payload.push({
                id: item.variants[0].id,
                quantity: triggerQuantity
            })
        })

        // add all products to cart
        await addProduct({items: payload});
    }

    // redirect to checkout
    window.location.href = "/checkout";

    // stop loading
    this.classList.remove("loading");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}